import React, { useState, useEffect } from "react";
import axios from "axios";

function Homework() {
  const [form, setForm] = useState({
    className: "",
    sectionName: "",
    subject: "",
    homework: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [teacher, setTeacher] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [homeworkList, setHomeworkList] = useState([]);

  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] placeholder:!text-[14px] focus:ring-2 focus:ring-blue-500";
  const sessionId = localStorage.getItem("currentSessionId");
  // Fetch teacher and related classes
useEffect(() => {
  const teacherRaw = localStorage.getItem("teacher");
  const sessionId = localStorage.getItem("currentSessionId");

  if (!teacherRaw || !sessionId) {
    console.error("Missing teacher or sessionId");
    return;
  }

  const teacherData = JSON.parse(teacherRaw);
  const teacherId = teacherData.id; 

  if (!teacherId) {
    console.error("Teacher ID missing");
    return;
  }

  const fetchTeacher = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
        { params: { sessionId } }
      );

      setTeacher(res.data);

      const { firstName, lastName } = res.data;
      fetchClasses(`${firstName} ${lastName}`);
    } catch (err) {
      console.error("Error fetching teacher:", err.response?.data || err.message);
    }
  };

  fetchTeacher();
}, []);




  // Fetch classes
  const fetchClasses = async (teacherName) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherClasses/${teacherName}`,
        { params: { sessionId } }
      );
      setClasses(response.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  // Fetch subjects for a selected class
  useEffect(() => {
    if (form.className) {
      fetchSubjects(form.className);
    }
  }, [form.className]);

  const fetchSubjects = async (className) => {
    if (!teacher) return;
    try {
      const { firstName, lastName } = teacher;
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getSubjectsByTeacherAndClass/${firstName}%20${lastName}/${className}`,
        { params: { sessionId } }
      );

      if (Array.isArray(response.data.subjects)) {
        setSubjects(response.data.subjects);
      } else {
        setSubjects([]);
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };
useEffect(() => {
  if (form.className && form.sectionName && form.subject) {
    fetchHomework(
      form.className,
      form.sectionName,
      form.subject
    );
  }
}, [form.className, form.sectionName, form.subject]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "className") {
      const [selectedClassName, selectedSectionName] = value.split("|");
      setForm({
        ...form,
        className: selectedClassName,
        sectionName: selectedSectionName || "",
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  // Handle submit
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  if (!form.className || !form.sectionName || !form.subject || !form.homework) {
    alert("All fields are required!");
    setIsLoading(false);
    return;
  }

  const homeworkPayload = {
    className: form.className,
    sectionName: form.sectionName,
    homework: {
      [form.subject]: form.homework,
    },
    sessionId: sessionId,
  };

  try {
    if (editingId) {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/homework/updateHomework/${editingId}`,
        homeworkPayload
      );
      alert("Homework Updated Successfully");
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/homework/submitHomeworkForDate`,
        homeworkPayload
      );
      alert("Homework Created Successfully");
    }

  
    await fetchHomework(
      form.className,
      form.sectionName,
      form.subject
    );

    // reset form
    setForm({
      className: form.className,     
      sectionName: form.sectionName,
      subject: form.subject,
      homework: "",
    });

    setEditingId(null);
  } catch (error) {
    console.error(
      "Error saving homework:",
      error.response?.data || error.message
    );
  } finally {
    setIsLoading(false);
  }
};

const fetchHomework = async (className, sectionName, subject) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/homework/getHomework/${className}/${sectionName}/${subject}`,
      {
        params: { sessionId }
      }
    );

    setHomeworkList(res.data);
  } catch (error) {
    if (error.response?.status === 404) {
      setHomeworkList([]); // No homework exists yet
    } else {
      console.error("Error fetching homework:", error);
    }
  }
};
const handleEdit = (hw) => {
  setEditingId(hw._id);
  setForm({
    className: hw.className,
    sectionName: hw.sectionName,
    subject: hw.subject,
    homework: hw.homework
  });
};

const handleDelete = async (id) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this homework?"
  );

  if (!confirmDelete) return;

  try {
    await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/homework/deleteHomework/${id}`,
      {
        params: { sessionId }
      }
    );

    // refresh homework list
    await fetchHomework(
      form.className,
      form.sectionName,
      form.subject
    );
  } catch (error) {
    console.error(
      "Error deleting homework:",
      error.response?.data || error.message
    );
  }
};


  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <i className="fas fa-pencil text-green-500 !text-[20px]" />
          <h1 className="font-bold !text-[18px]">Manage Homework</h1>
        </div>
        {editingId && (
          <span className="text-sm text-gray-500">
            Editing homework – <span className="font-semibold">Update mode</span>
          </span>
        )}
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Class */}
          <div className="flex flex-col">
            <label className={labelStyle}>Class:</label>
            <select
              name="className"
              value={
                form.className && form.sectionName
                  ? `${form.className}|${form.sectionName}`
                  : ""
              }
              onChange={handleInputChange}
              required
              className={inputStyle}
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option
                  key={cls._id}
                  value={`${cls.className}|${cls.sectionName}`}
                >
                  {cls.className} ({cls.sectionName})
                </option>
              ))}
            </select>
          </div>

          {/* Subject */}
          <div className="flex flex-col">
            <label className={labelStyle}>Subject:</label>
            <select
              name="subject"
              value={form.subject}
              onChange={handleInputChange}
              required
              disabled={!form.className}
              className={`${inputStyle} disabled:bg-gray-100`}
            >
              <option value="">Select Subject</option>
              {subjects.map((subject, index) => (
                <option key={index} value={subject}>
                  {subject}
                </option>
              ))}
            </select>
          </div>

          {/* Homework Text */}
          <div className="flex flex-col md:col-span-2">
            <label className={labelStyle}>Homework Details:</label>
            <textarea
              name="homework"
              value={form.homework}
              onChange={handleInputChange}
              required
              rows={4}
              placeholder="Enter homework instructions..."
              className={`${inputStyle} min-h-[100px] resize-y`}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-start gap-4 mt-4">
          <button
            type="submit"
            disabled={isLoading}
            className={`${
              isLoading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"
            } text-white px-4 py-2 rounded-lg !text-[14px] disabled:opacity-75`}
          >
            {isLoading
              ? "Saving..."
              : editingId
              ? "Update Homework"
              : "Add Homework"}
          </button>

          {editingId && (
            <button
              onClick={() => {
                setForm({
                  className: "",
                  sectionName: "",
                  subject: "",
                  homework: "",
                });
                setEditingId(null);
              }}
              type="button"
              className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg !text-[14px]"
            >
              Cancel
            </button>
          )}
        </div>
      </form>
      <div className="mt-10">
  {homeworkList.map((hw) => (
    <div
      key={hw._id}
      className="border rounded-lg p-4 mb-3 bg-gray-50 flex justify-between items-center"
    >
      {/* LEFT CONTENT */}
      <div>
        <p className="font-semibold text-sm text-gray-800">
          {hw.subject}
        </p>

        <p className="mt-1 text-gray-700 text-sm italic">
          "{hw.homework}"
        </p>

        <p className="text-xs text-gray-500 mt-2">
          Assigned on: {new Date(hw.dateAssigned).toDateString()}
        </p>
      </div>

      {/* RIGHT BUTTONS */}
      <div className="flex gap-2 items-center">
        <button
          onClick={() => {
            setEditingId(hw._id);
            setForm({
              className: hw.className,
              sectionName: hw.sectionName,
              subject: hw.subject,
              homework: hw.homework
            });
          }}
          className="px-3 py-1 text-sm bg-blue-500 hover:bg-blue-600 text-white rounded"
        >
          Edit
        </button>

        <button
          onClick={() => handleDelete(hw._id)}
          className="px-3 py-1 text-sm bg-red-500 hover:bg-red-600 text-white rounded"
        >
          Delete
        </button>
      </div>
    </div>
  ))}
</div>
    </div>
  );
}

export default Homework;
